import React, { useState, useCallback, useEffect } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useQuery } from "redux/action/api";
import { postApi, apiURL } from "redux/action/api_tbeams";
import {
  Card,
  Spinner,
  Table,
  Col,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { formatNumber } from "redux/action/api";
import RealiseCollectionPdfWebView from "components/RealiseCollectionPdfWebView";
import NewRelisePdfWebView from "components/NewRelisePdfWebView";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import moment from "moment";
import moment from "moment";
import { IoMdCheckmark } from "react-icons/io";
import { MdOutlineCancel } from "react-icons/md";
import { useToasts } from "helper/ToastAdapter";
import { fetchApi } from "redux/action/api_tbeams";
import { _fetchApi } from "redux/action/api";
import { _postApi } from "redux/action/api";
import RemarksList from "./Remarks";
import { getSector } from "helper";
import { getMDaType } from "helper";

export default function ViewRelease() {
  const navigate = useNavigate();
  const query = useQuery();
  const { addToast } = useToasts();
  const user = useSelector((e) => e.auth.user);
  const approval_status = query.get("approval_status");
  const return_status = query.get("return_status");
  const showButton = query.get("showButton");
  const approval_no = query.get("approval_no");
  const title = query.get("title");
  const types = query.get("type");
  const id = query.get("id");

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [submittingReview, setSubmittingReview] = useState(false);
  const [display, setDisplay] = useState(types !== "Budget Approval Released");
  const [form, setForm] = useState({ remark: "", rejact: "" });
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [discard, setDiscard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [budget_amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState([]);
  const [edit, setEdit] = useState(false);
  const toggle = () => setModal((prevState) => !prevState);
  const toggle1 = () => setModal1(!modal1);

  const [users, setUsers] = useState({});
  const [directors, setDirectors] = useState([]);
  const [createdBy, setCreatedBy] = useState(""); // For storing the username
  const [attachments, setAttachments] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [viewingAttachment, setViewingAttachment] = useState(null);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const discardToggle = () => setDiscard(!discard);
  const toggleEdit = () => setEdit(!edit);
  const toggleAttachmentModal = () => setAttachmentModal(!attachmentModal);

  const handleChanges = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const getRowStyle = (row) => {
    switch (row.approval_status) {
      case "Approval Released":
        return { backgroundColor: "orange" };
      case "Approval Processed":
        return { backgroundColor: "lightblue" };
      case "Approval Approved":
        return { backgroundColor: "lightgreen" };
      case "Approval Queried":
        return { backgroundColor: "yellow" };
      case "Payment Schedule":
        return { backgroundColor: "blue" };
      case "No Budget":
        return { backgroundColor: "#cc8888" };
      case "paid":
        return { backgroundColor: "green" };
      default:
        return { backgroundColor: "" };
    }
  };

  useEffect(() => {
    getSector({}, "select_director", setDirectors);
  }, []);

  const getApprovalCollection = useCallback(() => {
    setIsLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "select_by_approval_nos",
        approval_no,
      },
    })
      .then((data) => {
        setData(data.result);
        const _data = data.result.length ? data.result[0] : {};
        // alert(JSON.stringify(_data));

        // Fetch attachments
        if (_data.approval_no) {
          console.log(
            "Fetching attachments for approval_no:",
            _data.approval_no,
          );
          postApi(`fetch_approval_images`, {
            approval_no: _data.approval_no,
          })
            .then((response) => {
              console.log("Attachments response:", response);
              if (response.success && response.result) {
                // Handle both array formats
                const attachmentData = Array.isArray(response.result[0])
                  ? response.result[0]
                  : response.result;
                console.log("Processed attachments:", attachmentData);
                setAttachments(attachmentData || []);
              } else {
                console.log("No attachments found");
                setAttachments([]);
              }
            })
            .catch((err) => {
              console.log("Error fetching attachments:", err);
              setAttachments([]);
            });
        }

        // Fetch fullname if user_id exists
        if (_data.user_id) {
          fetchApi(`sign-by-id-new?id=${_data.user_id}`)
            .then((userData) => {
              console.log(userData, "KKDKDKDK");
              setCreatedBy(userData?.data[0]?.name || "Unknown");
            })
            .catch((err) => {
              console.log("Error fetching user:", err);
              setCreatedBy("Unknown");
            });
        }

        getMDaType(
          {},
          _data.mda_code,
          (d) => {
            setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
          },
          "select_sn",
        );
        _fetchApi(
          `/sign-by-id-new?id=${_data.approved_ids}`,
          (d) => {
            if (d.success) {
              setUsers(d?.data[0]);
            }
          },
          (err) => {
            console.log(err);
          },
        );
        postApi(`update_budget_balance`, {
          query_type: "select",
          mda_name: payable ? _data.mda_head : _data.mda_name,
          mda_code: payable ? _data.send_to_office : _data.mda_code,
          amount: null,
          economic_code: _data?.economic_code,
          program_code: _data?.program_code,
        })
          .then((d) => {
            // console.log("data", d);
            if (d.success) {
              const selectedItem = d.data[0];
              setAmount(selectedItem);
            }
          })
          .catch((err) => {
            // Handle errors
            console.log(err);
          })
          .finally(() => {
            setIsLoading(false);
          });

        // fetchApi(
        //   `get-budget-summary?query_type=fetch_budget&mda_code=${_data?.mda_code}&economic_code=${_data?.economic_code}`
        // ).then((d) => {
        //   console.log(d);
        //   if (d.result && d.result?.length) {
        //     console.log("Budget", d);
        //     const selectedItem = d.result[0];
        //     setAmount(selectedItem);
        //     console.log(d, "jhgjahg");
        //   }
        // });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  let styles = {
    fontSize: 15,
    padding: 2,
  };

  const bodyStyle = (item) => {
    return { fontSize: 15, padding: 2, ...getRowStyle(item) };
  };

  const _data = data.length ? data[0] : {};
  const pdfData = data.map((i) => ({
    ...i,
    approved_amount: i.amount,
    mda_economic_code: i.economic_code,
    description: i.description_code,
  }));
  const total = data.reduce((acc, item) => acc + parseFloat(item.amount), 0);
  const previewPdf = () => setDisplay(!display);

  useEffect(() => {
    getApprovalCollection();
  }, [getApprovalCollection]);

  let payable = _data.project_type === "payable-to";
  const updateBalance = () => {
    postApi(`update_budget_balance`, {
      query_type: "update_balance",
      mda_name: payable ? _data.mda_head : _data.mda_name,
      mda_code: payable ? _data.send_to_office : _data.mda_code,
      amount: total,
      economic_code: _data.economic_code,
      description: _data.description_code,
      geo_code: budget_amount.geo_code,
      program_code: _data.program_code,
      functional_code: budget_amount.functional_code,
      approval_no: _data.approval_no,
      admin_code: _data.mda_name,
      approval_no: _data.approval_no,
    })
      .then((data) => {
        console.log("data", data);
        if (data.success) {
          addToast("Balance updated", {
            appearance: "success",
            autoDismiss: true,
          });
        }
      })
      .catch((err) => {
        // Handle errors
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getCCCopies = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: _data.mda_name })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({
            ...p,
            ..._data,
            mda_sn: _data?.reference,
            approved_amount: _data.amount,
            copies: data.results[0],
            mda_economic_code: _data.economic_code,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [_data.mda_name]);

  const getCCCopies1 = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: _data.mda_head })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({
            ...p,
            ..._data,
            approved_amount: _data.amount,
            copies1: data.results[0],
            mda_economic_code: _data.economic_code,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [_data.mda_head]);

  const postRemarks = () => {
    postApi(`auditor_general_remark?query_type=insert`, {
      approval_no: id || approval_no,
      remark: form.remark,
      user_id: user.id,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
      .then(() => {
        _postRemarks();
        if (data.success) {
          addToast("Remarks added successfully", {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        addToast("An error occurred", {
          appearance: "danger",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      });
  };

  const _postRemarks = useCallback(() => {
    postApi(`auditor_general_remark`, {
      approval_no: id,
      remark: form.remark,
      user_id: user.id,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
      .then((data) => {
        setRemarks(data?.results);
        // console.log(data, "=======================DDDDD=======");
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id || approval_no]);

  useEffect(() => {
    getCCCopies();
    getCCCopies1();
  }, [getCCCopies, getCCCopies1]);

  useEffect(() => {
    _postRemarks();
  }, [_postRemarks]);

  const approveRequest = (status) => {
    // alert(JSON.stringify(data));
    setLoading(true);
    if (form.remark !== "") {
      postRemarks();
    }
    postApi(`update-approval`, {
      mda_name: _data.mda_name,
      approval_no: _data.approval_no,
      id: _data.id,
      status,
      remarks: form.remark,
      userId: user.id,
      query_type: "new-update",
    })
      .then((data) => {
        if (data.success) {
          if (discard) {
            discardToggle();
          } else {
            setModal(false);
          }
          setLoading(false);
          if (status?.includes("Budget Approval Released")) {
            updateBalance();
            // alert(JSON.stringify(status));
          }
          getApprovalCollection();
          navigate(-1);
          addToast("Approve successfully", {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        // Handle errors
        console.log(err);
        addToast("An error occurred", {
          appearance: "danger",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
        setLoading(false);
      })
      .finally(() => {
        // setIsUpdating(false);
        setLoading(false);
      });
  };

  const onEditClick = (item) => {
    setEdit(!edit);
    const newList = [];
    data.forEach((i) => {
      if (
        i.mda_code == item.mda_code &&
        i.economic_code === item.economic_code
      ) {
        newList.push({ ...i, editing: true });
      } else {
        newList.push(i);
      }
    });

    setData(newList);
  };

  const handleDataChange = (name, value, item) => {
    const newList = [];
    data.forEach((i) => {
      if (
        i.mda_code == item.mda_code &&
        i.economic_code === item.economic_code
      ) {
        newList.push({ ...i, [name]: value });
      } else {
        newList.push(i);
      }
    });

    setData(newList);
  };

  const submitReview = () => {
    setSubmittingReview(true);
    const modified = data
      .filter((a) => a.editing)
      .map((a) => ({
        ...a,
        approved_amount: a.amount,
        mda_economic_code: a.economic_code,
        approval_no: form.approval_no,
      }));
    postApi(`update_releases`, {
      approval_no: form.approval_no,
      id: id,
      query_type: "update_release",
      data: modified,
      userId: user.id,
    })
      .then((resp) => {
        console.log("resp", resp);
        if (resp.success) {
          setModal(false);
          getApprovalCollection();
          navigate(-1);
          addToast("Updated successfully", {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        // Handle errors
        console.log(err);
        addToast("An error occurred", {
          appearance: "danger",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setSubmittingReview(false);
      });
  };

  const [openRemark, setOpenRemark] = useState(false);
  const handleRemark = () => {
    setOpenRemark(!openRemark);
  };

  const newUser = title === "Signed Approvals" ? directors[0] : {};

  const handleDeleteApi = (item) => {
    let form = { ...item, query_type: "delete_release" };
    console.log(item);
    if (window.confirm("Are you sure you want to delete this item?")) {
      postApi(`post_approval_collection`, { form })
        .then(() => getApprovalCollection())
        .catch(console.log("Error occur"));
      console.log("Delete confirmed");
      getApprovalCollection();
    } else {
      console.log("Deleting cancel");
    }
  };

  return (
    <div>
      <DashboardLayout>
        <MDBox pt={2} pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {isLoading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "40px",
                  }}
                >
                  <Spinner color="success" />
                  <span style={{ marginLeft: "10px" }}>
                    Loading release details...
                  </span>
                </div>
              )}

              {!isLoading && (
                <>
                  {/* Header Section */}
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={3}
                    variant="gradient"
                    bgColor="success"
                    borderRadius="lg"
                    coloredShadow="success"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <MDTypography
                      variant="h5"
                      color="white"
                      style={{ fontWeight: 600 }}
                    >
                      Release No: {_data.approval_no}
                    </MDTypography>
                    <MDTypography
                      variant="body2"
                      color="white"
                      style={{ opacity: 0.9 }}
                    >
                      Status: {_data.approval_status}
                    </MDTypography>
                  </MDBox>

                  {/* Action Bar */}
                  <Row className="mt-4 mb-3 px-3">
                    <Col md={6} className="d-flex align-items-center">
                      <Button
                        color="warning"
                        size="md"
                        onClick={() => navigate(-1)}
                        style={{
                          fontWeight: 500,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        ← Back
                      </Button>
                    </Col>
                    <Col
                      md={6}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          padding: "12px 20px",
                          borderRadius: "8px",
                          border: "2px solid #e9ecef",
                          fontWeight: 600,
                        }}
                      >
                        Budget Balance:{" "}
                        <span style={{ color: "#28a745" }}>
                          ₦{formatNumber(budget_amount.mopb_balance)}
                        </span>
                      </div>
                    </Col>
                  </Row>

                  {/* Summary Information Card */}
                  {(types !== "Budget Approval Released" || display) && (
                    <div className="px-3 mb-4">
                      <Card
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          // overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "15px 20px",
                            borderBottom: "2px solid #dee2e6",
                            fontWeight: 600,
                            fontSize: "16px",
                          }}
                        >
                          Release Summary
                        </div>
                        <Table
                          responsive
                          hover
                          className="mb-0"
                          style={{ paddingBottom: 40 }}
                        >
                          <thead style={{ backgroundColor: "#f1f3f5" }}>
                            <tr>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Collection Date
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Approval Date
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Approved By
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Created By
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Total Amount
                              </th>
                              {title !== "Signed Approvals" && (
                                <th
                                  style={{
                                    padding: "15px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                  }}
                                >
                                  Actions
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {moment(_data?.collection_date).format(
                                  "MMM DD, YYYY",
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {moment(_data?.approval_date).format(
                                  "MMM DD, YYYY",
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <span
                                  style={{
                                    backgroundColor: "#e7f5ff",
                                    padding: "4px 12px",
                                    borderRadius: "4px",
                                    color: "#1971c2",
                                    fontWeight: 500,
                                  }}
                                >
                                  {_data?.approved_by}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {createdBy || (
                                  <Spinner size="sm" color="success" />
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    color: "#28a745",
                                  }}
                                >
                                  ₦{formatNumber(total)}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {types === "Initiated Returned" && (
                                    <UncontrolledButtonDropdown
                                      direction="right"
                                      style={{ zIndex: 500 }}
                                    >
                                      <DropdownToggle
                                        color="success"
                                        caret
                                        size="sm"
                                        style={{ fontWeight: 500 }}
                                      >
                                        Actions
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={() => {
                                            toggle1();
                                            setData([_data]);
                                          }}
                                        >
                                          <IoMdCheckmark
                                            size="18px"
                                            style={{ marginRight: 6 }}
                                          />
                                          Approve
                                        </DropdownItem>

                                        <DropdownItem
                                          onClick={() => {
                                            toggle();
                                            setData([_data]);
                                          }}
                                        >
                                          <MdOutlineCancel
                                            size="18px"
                                            style={{ marginRight: 6 }}
                                          />
                                          Return
                                        </DropdownItem>

                                        <DropdownItem
                                          onClick={() => {
                                            setDiscard(true);
                                            setData([_data]);
                                          }}
                                        >
                                          <MdOutlineCancel
                                            size="18px"
                                            style={{ marginRight: 6 }}
                                          />
                                          Discard / Delete
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledButtonDropdown>
                                  )}
                                  {/* Action buttons */}
                                  {types !== "Budget Approval Released" &&
                                    title !== "Signed Approvals" &&
                                    (showButton === true ||
                                    showButton === "true" ? null : (
                                      <UncontrolledButtonDropdown
                                        direction="right"
                                        style={{ zIndex: 500 }}
                                      >
                                        <DropdownToggle
                                          color="success"
                                          caret
                                          size="sm"
                                          style={{ fontWeight: 500 }}
                                        >
                                          Actions
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem
                                            onClick={() => {
                                              toggle1();
                                              setData([_data]);
                                            }}
                                          >
                                            <IoMdCheckmark
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Approve
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              toggle();
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Return
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              setDiscard(true);
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Discard / Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledButtonDropdown>
                                    ))}

                                  {/* {types !== "Budget Approval Released" &&
                                    title !== "Signed Approvals" &&
                                    types?.includes("Returned") && (
                                      <UncontrolledButtonDropdown
                                        direction="right"
                                        style={{ zIndex: 300 }}
                                      >
                                        <DropdownToggle
                                          color="success"
                                          caret
                                          size="sm"
                                          style={{ fontWeight: 500 }}
                                        >
                                          Actions
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem
                                            onClick={() => {
                                              toggle1();
                                              setData([_data]);
                                            }}
                                          >
                                            <IoMdCheckmark
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Approve
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              toggle();
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Return
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              setDiscard(true);
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Discard / Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledButtonDropdown>
                                    )} */}

                                  {types !== "Budget Approval Released" && (
                                    <Button
                                      color="link"
                                      size="sm"
                                      onClick={handleRemark}
                                      style={{
                                        color: "#ffc107",
                                        fontWeight: 500,
                                        textDecoration: "none",
                                      }}
                                    >
                                      View Remarks
                                    </Button>
                                  )}

                                  <Button
                                    color="link"
                                    size="sm"
                                    onClick={previewPdf}
                                    style={{
                                      color: display ? "#007bff" : "#dc3545",
                                      fontWeight: 500,
                                      textDecoration: "none",
                                    }}
                                  >
                                    {display
                                      ? "Preview Document"
                                      : "Close Document"}
                                  </Button>

                                  {attachments && attachments.length > 0 && (
                                    <Button
                                      color="link"
                                      size="sm"
                                      onClick={() =>
                                        setShowAttachments(!showAttachments)
                                      }
                                      style={{
                                        color: "#17a2b8",
                                        fontWeight: 500,
                                        textDecoration: "none",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      {showAttachments
                                        ? "Hide Attachments"
                                        : `View Attachments (${attachments.length})`}
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Card>
                    </div>
                  )}

                  {/* Attachments Section */}
                  {showAttachments && attachments.length > 0 && (
                    <div className="px-3 mt-3">
                      <Card
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#e3f2fd",
                            padding: "15px 20px",
                            borderBottom: "2px solid #2196f3",
                            borderLeft: "4px solid #2196f3",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "bold", color: "#1976d2" }}
                          >
                            Attachments ({attachments.length})
                          </MDTypography>
                        </div>
                        <div style={{ padding: "20px" }}>
                          <Row>
                            {attachments.map((file, idx) => (
                              <Col md={6} key={idx} className="mb-3">
                                <div
                                  style={{
                                    padding: "15px",
                                    border: "1px solid #dee2e6",
                                    borderRadius: "6px",
                                    backgroundColor: "#f8f9fa",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <MDTypography
                                      variant="body2"
                                      style={{
                                        fontWeight: 500,
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Attachment {idx + 1}
                                    </MDTypography>
                                    <MDTypography
                                      variant="caption"
                                      style={{ color: "#6c757d" }}
                                    >
                                      {file.image_url}
                                    </MDTypography>
                                  </div>
                                  <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => {
                                      setViewingAttachment(file);
                                      setAttachmentModal(true);
                                    }}
                                    style={{
                                      fontWeight: 500,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    View
                                  </Button>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      </Card>
                    </div>
                  )}

                  {/* Attachment Viewer Modal */}
                  <Modal
                    isOpen={attachmentModal}
                    toggle={toggleAttachmentModal}
                    size="xl"
                    style={{ maxWidth: "90vw" }}
                  >
                    <ModalHeader toggle={toggleAttachmentModal}>
                      View Attachment
                      {viewingAttachment && (
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#6c757d",
                            marginLeft: "10px",
                          }}
                        >
                          {viewingAttachment.image_url}
                        </span>
                      )}
                    </ModalHeader>
                    <ModalBody style={{ padding: 0, minHeight: "70vh" }}>
                      {viewingAttachment && (
                        <div
                          style={{
                            width: "100%",
                            height: "70vh",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#f5f5f5",
                            position: "relative",
                          }}
                          onContextMenu={(e) => e.preventDefault()}
                        >
                          {viewingAttachment.image_url
                            .toLowerCase()
                            .endsWith(".pdf") ? (
                            <iframe
                              src={`${apiURL}/uploads/${viewingAttachment.image_url}#toolbar=0&navpanes=0&scrollbar=0`}
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                              }}
                              title="PDF Viewer"
                            />
                          ) : (
                            <img
                              src={`${apiURL}/uploads/${viewingAttachment.image_url}`}
                              alt="Attachment"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                userSelect: "none",
                                pointerEvents: "none",
                              }}
                              onContextMenu={(e) => e.preventDefault()}
                              draggable={false}
                            />
                          )}
                        </div>
                      )}
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={toggleAttachmentModal}>
                        Close
                      </Button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={openRemark} toggle={handleRemark} size="lg">
                    <RemarksList remarks={remarks} />
                  </Modal>

                  {/* Content Section */}
                  <div className="px-3">
                    {isLoading ? (
                      <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spinner color="success" />
                      </div>
                    ) : display && types !== "Budget Approval Released" ? (
                      // Show detailed table
                      <Card
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "15px 20px",
                            borderBottom: "2px solid #dee2e6",
                            fontWeight: 600,
                            fontSize: "16px",
                          }}
                        >
                          Release Details
                        </div>
                        <Table
                          responsive
                          hover
                          className="mb-0"
                          style={{ fontSize: "14px" }}
                        >
                          <thead style={{ backgroundColor: "#f1f3f5" }}>
                            <tr>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Action
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                MDA
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                MDA Code
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Economic Code
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Activities
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Program
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  fontWeight: 600,
                                  textAlign: "right",
                                }}
                              >
                                Amount (₦)
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {data?.map((item, idx) => (
                              <tr key={idx} style={getRowStyle(item)}>
                                {/* {JSON.stringify(data.length)} */}
                                <td
                                  style={{
                                    padding: "12px",
                                    textAlign: "center",
                                  }}
                                >
                                  <Button
                                    onClick={() => onEditClick(item)}
                                    size="sm"
                                    color="success"
                                    disabled={
                                      item.approval_status ===
                                        "Approval Initiated" ||
                                      item.approval_status ===
                                        "approvals Reviewed" ||
                                      item.approval_status?.includes(
                                        " Returned",
                                      )
                                        ? false
                                        : true
                                    }
                                    style={{ fontWeight: 500 }}
                                  >
                                    Edit
                                  </Button>
                                  {data.length > 1 ? (
                                    <Button
                                      onClick={() => handleDeleteApi(item)}
                                      size="sm"
                                      color="danger"
                                      style={{ fontWeight: 500 }}
                                    >
                                      Del
                                    </Button>
                                  ) : null}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.mda_name}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.mda_code}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.economic_code}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.description_code}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.program_code}
                                </td>
                                <td
                                  style={{
                                    padding: "12px",
                                    textAlign: "right",
                                    fontWeight: 600,
                                  }}
                                >
                                  {formatNumber(item.amount)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Card>
                    ) : !display ||
                      (types === "Approval Released" && !display) ? (
                      // Show PDF webview
                      <div
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          overflow: "hidden",
                          backgroundColor: "#fff",
                        }}
                      >
                        {data.length === 1 ? (
                          <RealiseCollectionPdfWebView
                            form={form}
                            selecOffer={formatNumber}
                            user={newUser}
                            today={moment().format("LL")}
                            title={title}
                          />
                        ) : (
                          <NewRelisePdfWebView
                            selectedData={pdfData}
                            selecOffer={formatNumber}
                            imageUrl={newUser && newUser.imageUrl}
                            today={moment().format("LL")}
                            user={newUser}
                            title={title}
                          />
                        )}
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </MDBox>
        <Modal isOpen={discard} toggle={discardToggle}>
          <p
            style={{
              color: "red",
              fontWeight: "500",
            }}
          >
            Are you sure?
          </p>
          <ModalBody>
            <Col md={12}>
              <Label>Add Remark</Label>
              <Input
                type="textarea"
                name="remark"
                value={form.remark}
                onChange={handleChanges}
                style={{
                  borderColor: discard ? "red" : "#54AC58",
                  borderWidth: 2,
                }}
              />
            </Col>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={discardToggle}
            >
              Cancel
            </Button>

            <Button
              onClick={() => approveRequest("Discard")}
              disabled={loading}
              color="primary"
              variant="primary"
              className="btn btn-primary"
            >
              {loading ? "Loading..." : "Discard"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader>
            <span className="text-center" style={{ width: "100%" }}>
              <center>
                <p
                  style={{
                    color: "red",
                    fontWeight: "500",
                  }}
                >
                  Are you sure?
                </p>
              </center>
            </span>
          </ModalHeader>
          <ModalBody>
            <Col md={12}>
              <Label>Add Remark</Label>
              <Input
                type="textarea"
                name="remark"
                value={form.remark}
                onChange={handleChanges}
                style={{
                  borderColor: "red",
                  borderWidth: 2,
                }}
              />
            </Col>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={toggle}
            >
              Cancel
            </Button>

            <Button
              variant="danger"
              className="btn btn-danger"
              onClick={() => {
                approveRequest(return_status);
                toggle1();
              }}
              disabled={loading}
            >
              Return
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={modal1} toggle={toggle1}>
          <ModalHeader>
            <span className="text-center" style={{ width: "100%" }}>
              <center>
                <p
                  style={{
                    color: "#54AC58",
                    fontWeight: "500",
                  }}
                >
                  Are you sure?
                </p>
              </center>
            </span>
          </ModalHeader>
          <ModalBody>
            <Col md={12}>
              <Label>Add Remark</Label>
              <Input
                type="textarea"
                name="remark"
                value={form.remark}
                onChange={handleChanges}
                style={{
                  borderColor: "#54AC58",
                  borderWidth: 2,
                }}
              />
            </Col>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={toggle1}
            >
              Cancel
            </Button>
            <Button
              onClick={() => approveRequest(approval_status)}
              disabled={loading}
              color="primary"
              variant="primary"
              className="btn btn-primary"
            >
              {loading ? "Loading..." : "Approve"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={edit} toggle={toggleEdit} size="lg">
          <ModalHeader>
            {/* {JSON.stringify()} */}
            <div className="d-flex">
              <div className="w-100">
                <small>Approval No.</small>
              </div>
              <Input
                type="text"
                name="approval_no"
                value={form.approval_no}
                onChange={handleChanges}
                size="sm"
                defaultValue={_data.approval_no}
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Table
              size="sm"
              className="table-bordered table-responsive table-zebra table-hover"
              style={{ zIndex: 10 }}
            >
              <thead size="sm">
                <tr>
                  <th style={styles}>Narration</th>
                  <th style={styles}>Amount</th>
                  <th style={styles}>MDA</th>
                  <th style={styles}>MDA code</th>
                  <th style={styles}>Activities</th>
                  <th style={styles}>Economic code</th>
                  <th style={styles}>Program</th>
                </tr>
              </thead>

              <tbody>
                {data?.map((item, idx) => (
                  <tr key={idx}>
                    <td
                      style={{
                        ...bodyStyle(item),
                        textAlign: "center",
                      }}
                    >
                      <Input
                        type="textarea"
                        value={item.narration}
                        onChange={({ target: { value } }) =>
                          handleDataChange("narration", value, item)
                        }
                      />
                    </td>
                    <td
                      style={{
                        ...bodyStyle(item),
                        textAlign: "right",
                      }}
                    >
                      <Input
                        value={item.amount}
                        onChange={({ target: { value } }) =>
                          handleDataChange("amount", value, item)
                        }
                      />
                    </td>

                    <td style={bodyStyle(item)}>
                      <Input
                        value={item.mda_name}
                        onChange={({ target: { value } }) =>
                          handleDataChange("mda_name", value, item)
                        }
                      />
                    </td>
                    <td style={bodyStyle(item)}>
                      <Input
                        value={item.mda_code}
                        onChange={({ target: { value } }) =>
                          handleDataChange("mda_code", value, item)
                        }
                      />
                    </td>
                    <td style={bodyStyle(item)}>
                      <Input
                        value={item.description_code}
                        onChange={({ target: { value } }) =>
                          handleDataChange("description_code", value, item)
                        }
                      />
                    </td>
                    <td style={bodyStyle(item)}>
                      <Input
                        value={item.economic_code}
                        onChange={({ target: { value } }) =>
                          handleDataChange("economic_code", value, item)
                        }
                      />
                    </td>
                    <td style={bodyStyle(item)}>
                      <Input
                        value={item.program_code}
                        onChange={({ target: { value } }) =>
                          handleDataChange("program_code", value, item)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={toggleEdit}
            >
              Cancel
            </Button>
            <Button
              color="success"
              onClick={submitReview}
              disabled={submittingReview}
            >
              Submit Review
            </Button>
          </ModalFooter>
        </Modal>
      </DashboardLayout>
    </div>
  );
}
